import { Phone } from "lucide-react";
import { SITE } from "@/data/site";

export default function StickyCallButton() {
  return (
    <a
      href={`tel:${SITE.phoneTel}`}
      data-testid="sticky-call-button"
      aria-label={`Call ${SITE.phoneDisplay}`}
      className="md:hidden fixed right-4 bottom-5 z-40 inline-flex items-center justify-center w-14 h-14 rounded-full bg-amber-400 text-slate-900 shadow-2xl shadow-amber-500/40 active:scale-95 transition-transform"
    >
      <Phone className="w-6 h-6" />
    </a>
  );
}
